// export default EmployeeAttendance;
import React, { useState, useEffect } from "react";
import "../assets/css/EmployeeAttendance.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";


const EmployeeAttendance = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);

  const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString().slice(0, 7));
  const [attendanceData, setAttendanceData] = useState([]);
  const [summary, setSummary] = useState({ present: 0, absent: 0, halfday: 0, leave: 0 });
  const [loadingAction, setLoadingAction] = useState(false); // ✅ global loading flag

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    if (!profile?.id) return;
    fetchAttendanceData();
  }, [profile?.id, selectedMonth]);

  const fetchAttendanceData = async () => {
    try {
      const res = await fetch(
        `https://payyug.in/api/attendance/status?employee_id=${profile.id}&month=${selectedMonth}`
      );
      const result = await res.json();
      if (result.data) {
        const mapped = result.data.map((r) => ({
          date: r.date,
          checkIn: r.checkInTime || "--",
          checkOut: r.checkOutTime || "--",
          status: r.status || "absent",
        }));
        setAttendanceData(mapped);
        calculateSummary(mapped);
      }
    } catch (err) {
      toast.error("❌ Failed to load attendance data!");
    }
  };

  const calculateSummary = (data) => {
    const counts = { present: 0, absent: 0, halfday: 0, leave: 0 };
    data.forEach((d) => {
      if (d.status.toLowerCase().includes("present")) counts.present++;
      else if (d.status.toLowerCase().includes("absent")) counts.absent++;
      else if (d.status.toLowerCase().includes("half")) counts.halfday++;
      else if (d.status.toLowerCase().includes("leave")) counts.leave++;
    });
    setSummary(counts);
  };

  // ✅ Shared fetch helper
  const callAttendanceAPI = async (url, successMsg, alreadyMsg) => {
    setLoadingAction(true);
    try {
      const payload = { employee_id: profile.id, admin_id: profile.superAdminId };
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (res.status === 409) {
        toast.info(alreadyMsg);
        return;
      }

      let result = {};
      try {
        result = await res.json();
      } catch {}

      if (res.ok) {
        toast.success(successMsg);
        fetchAttendanceData();
      } else {
        toast.error(`❌ Failed: ${result.message || res.statusText}`);
      }
    } catch (err) {
      toast.error("🚨 Network error, please try again!");
    } finally {
      setLoadingAction(false);
    }
  };

  const handleCheckIn = () =>
    callAttendanceAPI(
      "https://payyug.in/api/create-attendence",
      "✅ Checked In Successfully!",
      "⚠️ You have already checked in today!"
    );

  const handleCheckOut = () =>
    callAttendanceAPI(
      "https://payyug.in/api/checkout-attendence",
      "✅ Checked Out Successfully!",
      "⚠️ You have already checked out today!"
    );

  return (
    <div className="SuperAdminAttendance-container">
      <h1 className="SuperAdminAttendance-title">Employee Attendance</h1>

      {/* Month Filter */}
      <div className="SuperAdminAttendance-filterGroup">
        <label className="SuperAdminAttendance-label">Select Month</label>
        <input
          type="month"
          className="SuperAdminAttendance-input"
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(e.target.value)}
        />
      </div>

      {/* Summary Cards */}
      <div className="SuperAdminAttendance-summary">
        <div className="SuperAdminAttendance-card green">
          <h2>Present</h2>
          <p>{summary.present}</p>
        </div>
        <div className="SuperAdminAttendance-card red">
          <h2>Absent</h2>
          <p>{summary.absent}</p>
        </div>
        <div className="SuperAdminAttendance-card purple">
          <h2>Half Day</h2>
          <p>{summary.halfday}</p>
        </div>
        <div className="SuperAdminAttendance-card blue">
          <h2>Leave</h2>
          <p>{summary.leave}</p>
        </div>
      </div>

      {/* ✅ Action Buttons */}
      <div className="action-buttons">
        <button
          className="btn-checkin"
          onClick={handleCheckIn}
          disabled={loadingAction}
        >
          {loadingAction ? "Processing..." : "Check In"}
        </button>
        <button
          className="btn-checkout"
          onClick={handleCheckOut}
          disabled={loadingAction}
        >
          {loadingAction ? "Processing..." : "Check Out"}
        </button>
      </div>

      {/* Attendance Table */}
      <div className="SuperAdminAttendance-tableWrapper">
        <table className="SuperAdminAttendance-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Check-In</th>
              <th>Check-Out</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
              {attendanceData.map((row, index) => (
                <tr key={index}>
                  <td>{new Date(row.date).toLocaleDateString("en-GB").replaceAll("/","-")||"N/A"}</td>
                  <td>{row.checkIn}</td>
                  <td>{row.checkOut}</td>
                  <td>
                    <span className={`status-badge ${row.status.toLowerCase()}`}>
                      {row.status}
                    </span>
                  </td>
                </tr>
              ))}
            {attendanceData.length === 0 && (
              <tr>
                <td colSpan="4" style={{ textAlign: "center", color: "#999" }}>
                  No attendance data available for this month.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EmployeeAttendance;
